import type { Translation } from '../types.ts';
import type en from '../en/auth.ts';

export default {
    login: {
        subtitle: 'Log in om verder te gaan',
        password: 'Wachtwoord',
        submit: 'Inloggen',
        submitting: 'Inloggen…',
        passkey: 'Inloggen met een toegangssleutel',
        passkeyWaiting: 'Wachten op toegangssleutel…',
        failed: 'Inloggen is mislukt.',
        throttled: 'Te veel inlogpogingen. Probeer het over {n} minuut opnieuw. | Te veel inlogpogingen. Probeer het over {n} minuten opnieuw.',
        passkeyFailed: 'Inloggen met toegangssleutel is mislukt.',
    },
    passkeys: {
        creationCancelled: 'De browser heeft het aanmaken van de toegangssleutel geannuleerd.',
        selectionCancelled: 'De browser heeft het kiezen van een toegangssleutel geannuleerd.',
    },
} satisfies Translation<typeof en>;
